export default __webpack_public_path__ + "static/media/bg4.d1f115a7.jpg";